function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h240v240H0z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M45.142 57.515c2.138-.699 3.308-3.009 2.613-5.16a4.066 4.066 0 00-5.13-2.627c-2.137.699-3.307 3.008-2.612 5.159a4.066 4.066 0 005.13 2.628zM54.028 44.156a2.787 2.787 0 001.777-3.508 2.765 2.765 0 00-3.488-1.787 2.788 2.788 0 00-1.777 3.508 2.765 2.765 0 003.488 1.787zM187.474 58.21a6.249 6.249 0 00.394-8.793 6.163 6.163 0 00-8.742-.395 6.249 6.249 0 00-.393 8.792 6.162 6.162 0 008.741.396zM207.238 46.863a2.63 2.63 0 00.165-3.702 2.594 2.594 0 00-3.68-.167 2.63 2.63 0 00-.166 3.702 2.595 2.595 0 003.681.167zM52.295 192.341a2.632 2.632 0 00.166-3.703 2.595 2.595 0 00-3.681-.166 2.631 2.631 0 00-.166 3.702 2.595 2.595 0 003.68.167z",
  fill: "#EBF0F7"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M117.99 201c44.693 0 80.925-36.442 80.925-81.396 0-44.953-36.232-81.395-80.925-81.395-44.694 0-80.925 36.442-80.925 81.395 0 44.954 36.231 81.396 80.925 81.396z",
  fill: "#EBF0F7",
  stroke: "#D2D8E1",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M97.902 42.568v100.55a4.075 4.075 0 01-4.079 4.074H11.078A4.075 4.075 0 017 143.118V42.568a4.074 4.074 0 014.078-4.074h82.746a4.074 4.074 0 014.078 4.074z",
  fill: "#fff",
  stroke: "#D2D8E1",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M97.902 42.492v9.47H7v-9.47c0-2.209 1.824-3.998 4.078-3.998h82.746c2.253 0 4.078 1.789 4.078 3.998z",
  fill: "#EBF0F7",
  stroke: "#D2D8E1",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M13.012 47.633a2.164 2.164 0 100-4.329 2.164 2.164 0 000 4.329zM19.745 47.633a2.164 2.164 0 100-4.33 2.164 2.164 0 000 4.33zM26.479 47.633a2.164 2.164 0 100-4.329 2.164 2.164 0 000 4.329z",
  fill: "#D2D8E1"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M86.666 126.513h-9.85c-.965 0-1.821-.749-1.821-1.82V72.331c0-.963.75-1.82 1.82-1.82h9.851c.964 0 1.82.75 1.82 1.82v52.362c0 .963-.749 1.82-1.82 1.82z",
  fill: "#EBF0F7",
  stroke: "#D2D8E1",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M86.666 126.513h-9.85c-.965 0-1.821-.75-1.821-1.82V91.177c0-.964.75-1.82 1.82-1.82h9.851c.964 0 1.82.75 1.82 1.82v33.516c0 .963-.749 1.82-1.82 1.82z",
  fill: "#EBF0F7",
  stroke: "#D2D8E1",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M67.071 126.513H57.22c-.964 0-1.82-.749-1.82-1.82V72.331c0-.963.75-1.82 1.82-1.82h9.851c.964 0 1.82.75 1.82 1.82v52.362c0 .963-.856 1.82-1.82 1.82z",
  fill: "#EBF0F7"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M67.071 126.513H57.22c-.964 0-1.82-.75-1.82-1.82v-19.489c0-.963.75-1.82 1.82-1.82h9.851c.964 0 1.82.75 1.82 1.82v19.489c0 .963-.856 1.82-1.82 1.82z",
  fill: "#D2D8E1"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M47.476 126.513h-9.852c-.963 0-1.82-.749-1.82-1.82V72.331c0-.963.75-1.82 1.82-1.82h9.852c.964 0 1.82.75 1.82 1.82v52.362c-.107.963-.856 1.82-1.82 1.82z",
  fill: "#EBF0F7"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M47.476 126.513h-9.852c-.963 0-1.82-.749-1.82-1.82V84.217c0-.964.75-1.82 1.82-1.82h9.852c.964 0 1.82.75 1.82 1.82v40.476c-.107.963-.856 1.82-1.82 1.82z",
  fill: "#D2D8E1"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M27.773 126.513h-9.851c-.964 0-1.82-.749-1.82-1.82V72.331c0-.963.75-1.82 1.82-1.82h9.851c.964 0 1.82.75 1.82 1.82v52.362c0 .963-.856 1.82-1.82 1.82z",
  fill: "#EBF0F7"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M27.773 126.512h-9.851c-.964 0-1.82-.749-1.82-1.82v-18.203c0-.964.75-1.821 1.82-1.821h9.851c.964 0 1.82.75 1.82 1.821v18.203c0 .964-.856 1.82-1.82 1.82z",
  fill: "#D2D8E1"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M233.533 103.807v92.542a3.74 3.74 0 01-3.733 3.749h-75.741a3.74 3.74 0 01-3.733-3.749v-92.542a3.74 3.74 0 013.733-3.749H229.8a3.74 3.74 0 013.733 3.749z",
  fill: "#fff",
  stroke: "#D2D8E1",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M221.131 152.963h-45.249v8.283h45.249v-8.283z",
  fill: "#fff",
  stroke: "#D2D8E1",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M175.658 161.231h-11.384v26.346h11.384v-26.346z",
  fill: "#EBF0F7",
  stroke: "#D2D8E1",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M221.116 152.963h-45.458v34.629h45.458v-34.629z",
  fill: "#fff",
  stroke: "#D2D8E1",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M209.913 187.577h-45.639v-26.346h56.857M221.131 170.263h-56.857M221.131 178.92h-56.857M187.131 152.963v34.614M198.484 152.963v34.614M209.838 152.963v34.614",
  stroke: "#D2D8E1",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M220.072 122.536a2.456 2.456 0 01-.5 3.411l-17.794 13.351a2.392 2.392 0 01-2.833.03l-6.133-4.399-11.047 6.998a2.389 2.389 0 01-2.533.018l-3.336-2.05-7.961 4.871a2.397 2.397 0 01-3.312-.824 2.454 2.454 0 01.815-3.348l9.212-5.636a2.39 2.39 0 012.502.002l3.313 2.037 11.149-7.063a2.39 2.39 0 012.676.077l6.019 4.317 16.389-12.296a2.394 2.394 0 013.374.504z",
  fill: "#D2D8E1"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M233.533 103.77v8.793h-83.207v-8.793c0-2.052 1.67-3.712 3.733-3.712H229.8c2.063 0 3.733 1.66 3.733 3.712z",
  fill: "#EBF0F7",
  stroke: "#D2D8E1",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M170.046 100.538v78.189c0 2.241-1.825 4.056-4.078 4.056h-15.642v-78.496a3.74 3.74 0 013.733-3.749h15.987z",
  fill: "#D2D8E1"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M164.755 74.774V174.88c0 2.241-1.824 4.055-4.078 4.055H77.932c-2.254 0-4.078-1.814-4.078-4.055V74.774c0-2.241 1.824-4.055 4.078-4.055h82.745c2.254 0 4.078 1.814 4.078 4.055z",
  fill: "#fff",
  stroke: "#D2D8E1",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M164.755 74.717v9.469H73.854v-9.47c0-2.209 1.824-3.997 4.078-3.997h82.745c2.254 0 4.078 1.788 4.078 3.998z",
  fill: "#EBF0F7",
  stroke: "#D2D8E1",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M79.866 79.857a2.164 2.164 0 100-4.328 2.164 2.164 0 000 4.328zM86.6 79.857a2.164 2.164 0 100-4.328 2.164 2.164 0 000 4.328zM93.333 79.857a2.164 2.164 0 100-4.328 2.164 2.164 0 000 4.328z",
  fill: "#D2D8E1"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.7,
  d: "M131.746 128.44l-4.39-2.142a10.47 10.47 0 01-7.924 3.641c-5.782 0-10.493-4.711-10.493-10.494 0-.749.107-1.392.214-2.141l-4.39-2.142-9.423-4.604c-1.071 2.998-1.714 6.318-1.5 9.851.536 13.385 11.458 24.2 24.736 24.628 9.53.321 17.989-4.604 22.593-11.993l-9.423-4.604zm-12.421-34.693c-9.208 0-17.346 4.818-21.844 12.207l9.423 4.604 4.39 2.142c1.714-1.928 4.069-3.32 6.746-3.641l.643-4.819 1.285-10.386c-.214-.107-.429-.107-.643-.107zm5.783.642l-1.285 10.387-.643 4.818c3.855 1.499 6.639 5.354 6.639 9.744 0 .75-.107 1.499-.214 2.142l4.39 2.142 9.423 4.604c1.071-2.784 1.606-5.782 1.606-8.888v-.107c-.107-11.993-8.566-22.165-19.916-24.842z",
  fill: "#D2D8E1"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M119.325 93.747c-9.208 0-17.346 4.818-21.844 12.207l9.423 4.604 4.391 2.142c1.713-1.928 4.069-3.32 6.745-3.641l.643-4.819 1.285-10.386c-.214-.107-.428-.107-.643-.107z",
  fill: "#EBF0F7"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M125.108 94.39l-1.285 10.386-.643 4.818c3.855 1.499 6.639 5.354 6.639 9.744 0 .75-.107 1.5-.214 2.142l4.39 2.142 9.423 4.604c1.071-2.784 1.606-5.782 1.606-8.888v-.107c-.107-11.992-8.566-22.165-19.916-24.842z",
  fill: "#D2D8E1"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "M111.295 112.7l-4.391-2.142c2.677-3.641 6.853-6.103 11.672-6.318l-.642 4.819c-2.57.321-4.926 1.606-6.639 3.641zM127.356 126.299l4.391 2.141c-2.784 3.855-7.282 6.318-12.422 6.318-8.459 0-15.312-6.853-15.312-15.312 0-1.499.214-2.891.643-4.283l4.39 2.141c-.107.643-.214 1.392-.214 2.142 0 5.782 4.711 10.493 10.493 10.493 3.213 0 6.104-1.392 8.031-3.64zM134.638 119.446c0 1.499-.214 2.998-.643 4.283l-4.39-2.141c.107-.75.214-1.392.214-2.142 0-4.39-2.784-8.245-6.639-9.744l.643-4.819c6.21 1.821 10.815 7.71 10.815 14.563z",
  fill: "#353C50",
  fillOpacity: 0.4
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M143.036 152.963H94.13a2 2 0 00-2 2v.329a2 2 0 002 2h48.906a2 2 0 002-2v-.329a2 2 0 00-2-2zM116.102 163.544H94.13a2 2 0 00-2 2v.329a2 2 0 002 2h21.972a2 2 0 002-2v-.329a2 2 0 00-2-2z",
  fill: "#D2D8E1"
});

function SvgNoData(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 240,
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30);
}

export default SvgNoData;